export const DELETE_CARD = 'delete-card'
export const MOVEMENT_ITEM_CARD_LOCATION_CHANGED = 'movement-item-card-location-changed'
export const UPDATE_ITEM_MOVEMENT_PAGE = 'update-item-movement-page'